export const RESET_THEME = 'uwave/debug/RESET_THEME';
export const APPLY_THEME = 'uwave/debug/APPLY_THEME';
